import { Injectable, Injector } from '@angular/core';
import { BaseService } from './base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SOPService extends BaseService {
  private readonly GetSOPInformationURL = this.generateAPIUrl('SOP/GetSOPInformation');

  constructor(private injector: Injector) {
    super(injector)
  }

  public getSOPInformation(payload: any): Observable<any> {
    return this.http.post<any>(this.GetSOPInformationURL, payload);
  }
}
